<template>
  <div class="review">
    <img :src="image" :alt="title" class="review__image">
    <div class="review__title">{{ title }}</div>
    <div class="review__text">{{ text }}</div>
    <div class="buttons">
      <a target="_blank" href="https://vk.com/topic-211119672_50270760?offset=1260">О нас в Вк</a>
      <a
          target="_blank"
          href="https://max.ru/id6455072031_biz"
          class="footer__info-social"
      >
        О нас в Max
      </a>
      <a target="_blank" href="https://yandex.ru/maps/194/saratov/?ll=45.930097%2C51.552423&mode=poi&poi%5Bpoint%5D=45.928405%2C51.553994&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D1745847729&tab=reviews&z=17">О нас на Яндекс</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      image: {
        default: '',
        type: String
      },
      title: {
        default: '',
        type: String
      },
      text: {
        default: '',
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
.buttons {
  max-width: 400px;
  width: 100%;
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 890px) {
    max-width: none;

    a {
      width: 100%;
      text-align: center;
    }
  }

  a {
    background-color: #f98419;
    padding: 10px 20px;
    border-radius: 30px;
    color: #fff;
    font-family: RF Dewi Expanded;
    font-weight: 900;
    text-decoration: none;
  }
}
  .review {
    background-color: white;
    border-radius: 30px;
    display: flex;
    flex-wrap: wrap;
    padding: 54px 50px;
    width: 680px;
    margin: 0 auto;
    user-select: none;
    @media screen and (max-width: 1300px){
      width: 620px;
    }
    @media screen and (max-width: 890px) {
      max-width: 500px;
      width: 60vw;
      padding: 54px 25px;
    }
    &__image {
      width: 140px;
      margin: 0 auto;
      object-fit: contain;
    }
    &__title {
      font-family: RF Dewi Expanded;
      font-size: 20px;
      font-weight: 900;
      line-height: 27px;
      text-align: center;
      width: 100%;
      margin: 20px 0;
    }
    &__text {
      font-family: Montserrat;
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      text-align: center;
      width: 100%;
    }
  }
</style>